import { render, staticRenderFns } from "./AttributesPage.vue?vue&type=template&id=04105dfe&scoped=true"
import script from "./AttributesPage.vue?vue&type=script&lang=ts"
export * from "./AttributesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04105dfe",
  null
  
)

export default component.exports